import { render, staticRenderFns } from "./ProconAverageComplaintsSixMonths.vue?vue&type=template&id=9f26fa0e&"
import script from "./ProconAverageComplaintsSixMonths.vue?vue&type=script&lang=ts&"
export * from "./ProconAverageComplaintsSixMonths.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports